export function isImage(file: File): boolean {
  const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

  return file && acceptedImageTypes.includes(file.type);
}

export function getAcceptDisplayText(
  accept: string,
  separator: string = ' or '
): string {
  if (!accept) {
    return '';
  }

  return accept
    .split(',')
    .map((x) => '*' + x.trim())
    .join(separator);
}
